var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("filogix-loader")
    : _c(
        "b-row",
        { attrs: { "no-gutters": "" } },
        [
          _vm.IS_APPLICATION_SYNCABLE(_vm.applicationId)
            ? _c("filogix-navigation", {
                attrs: { page: _vm.page },
                on: { "page-change": _vm.handlePageChange },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.page === "automatic-sync"
            ? _c(
                "div",
                { staticClass: "w-100" },
                [
                  _c("application-sync-status", {
                    attrs: {
                      "application-id": _vm.applicationId,
                      "client-username": _vm.clientUsername,
                      "updating-sync-status": _vm.loadingSyncStatus,
                    },
                    on: { "update-sync-status": _vm.handleUpdateSyncStatus },
                  }),
                  _vm._v(" "),
                  _c("application-sync-history", {
                    attrs: {
                      "application-id": _vm.applicationId,
                      "client-username": _vm.clientUsername,
                      "updating-sync-status": _vm.loadingSyncStatus,
                    },
                  }),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "w-100" },
                [
                  _c("submit-card", {
                    attrs: {
                      "client-username": _vm.clientUsername,
                      "application-id": _vm.applicationId,
                    },
                  }),
                  _vm._v(" "),
                  _c("deals-card", {
                    attrs: {
                      "client-username": _vm.clientUsername,
                      "application-id": _vm.applicationId,
                      "agent-username": _vm.agentUsername,
                    },
                  }),
                ],
                1
              ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }